import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './InfoDrawer.styles';
import { Drawer } from '@/components/Drawer/Drawer';
import { InfoOutlinedIcon } from '@/components/UI/Icons/Icons';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { ROUTES } from '@/constants/routes';

interface InfoDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  description: string;
}

export const InfoDrawer: FC<InfoDrawerProps> = ({
  isOpen,
  onClose,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer isOpen={isOpen} isHeadHidden close={onClose}>
      <S.Wrapper>
        <S.Logo $filename="Tap.svg" $width={60} $height={18} />
        <InfoOutlinedIcon />
        <Typography.Header $variant="2">
          {t('common.attention')}
        </Typography.Header>
        <S.Text $variant="1">{description}</S.Text>
        <Button appearance="secondaryLight" isFullWidth onClick={onClose}>
          {t('common.got_it')}
        </Button>
        <S.Link as={CustomLink} href={ROUTES.payments}>
          {t('pages.cabinet.operations_history')}
        </S.Link>
      </S.Wrapper>
    </Drawer>
  );
};
